// import 'core-js/stable'
// import 'regenerator-runtime/runtime'

import createApp from './createApp'
import preFetchAsync from 'app/web/framework/preFetchAsync.js'
import client from 'app/web/framework/client.js'
// import '@babel/polyfill'
import Vue from 'vue'

// 务必在加载 Vue 之后，立即同步设置以下内容
if (process.env.NODE_ENV !== 'production') {
  Vue.config.devtools = true
}

window.catchVueErrorFromHeadScript(Vue)

const { app, router, store } = createApp({
  ua: window.navigator.userAgent
})

Vue.use(client, { app, router, store })

app.$watch(
  () => store.state.userinfo,
  val => {
    if (val && val.id) {
      window.monitor.setGlobalData({ userId: val.id })
    }
  },
  { deep: true }
)

router.onReady(() => {
  if (window.__INITIAL_STATE__) {
    const matchedComponents = router.getMatchedComponents()
    matchedComponents.forEach(component => {
      if (component.dataStore) {
        let storeList = []
        if (Array.isArray(component.dataStore)) {
          storeList = [...component.dataStore]
        } else {
          storeList = [component.dataStore]
        }

        storeList.forEach(ds => {
          const { name, store: _store } = ds
          if (!store.state[name]) {
            store.registerModule(name, _store, {})
          }
        })
      }
    })

    store.replaceState(window.__INITIAL_STATE__)

    app.$mount('#app')
  } else {
    preFetchAsync(router, store, null, undefined).then(() => {
      app.$mount('#app')
    })
  }

  router.beforeResolve((to, from, next) => {
    preFetchAsync(router, store, null, undefined, to).then(next).catch(next)
  })

  router.afterEach((to, from) => {
    let matchedComponents = router.getMatchedComponents(from)
    const preMatchedComponents = router.getMatchedComponents(to)
    matchedComponents = matchedComponents.filter(v =>
      preMatchedComponents.find(_v => {
        return _v.dataStore?.name !== v.dataStore?.name
      })
    )
    matchedComponents.forEach(component => {
      if (component.dataStore) {
        store.unregisterModule(component.dataStore.name)
      }
    })
  })
})
